export default "__VITE_ASSET__BINiTfU4__"